export default "__VITE_ASSET__6f87f578__"